import { graphql } from '@generated/gql';

export const CHANGE_AVATAR_MODAL_ME = graphql(/** GraphQL */ `
  query changeAvatarModalMe {
    me {
      id
      avatar
    }
  }
`);

export const CHANGE_AVATAR_MODAL_FETCH_FILE_UPLOAD_URL =
  graphql(/** GraphQL */ `
  query changeAvatarModalFetchFileUploadUrl($input: FetchFileUploadUrlInput!) {
    fetchFileUploadUrl(input: $input) {
      temporarySignedURL
      timestamp
    }
  }
`);

export const CHANGE_AVATAR_MODAL_CREATE_FILE_DOCUMENT = graphql(/** GraphQL */ `
  mutation changeAvatarModalCreateFileDocument($input: CreateFileDocumentInput!) {
    createFileDocument(input: $input) {
      fileDocument {
        id
      }
    }
  }
`);

export const CHANGE_AVATAR_MODAL_DELETE_FILE_DOCUMENT = graphql(/** GraphQL */ `
  mutation changeAvatarModalDeleteFileDocument($fileDocumentId: ObjectID!) {
    deleteFileDocument(input: { fileDocumentId: $fileDocumentId }) {
      fileDocument {
        id
      }
    }
  }
`);

export const CHANGE_AVATAR_MODAL_UPDATE_AVATAR = graphql(/** GraphQL */ `
  mutation changeAvatarModalUpdateOrganizationUserProfile(
    $input: UpdateOrganizationUserProfileInput!
  ) {
    updateOrganizationUserProfile(input: $input) {
      organizationUser {
        id
        avatar
      }
    }
  }
`);
